import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import NotificationBell from './NotificationBell';
import { signOut } from '../lib/supabase';

export default function Navbar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    setOpen(false);
    navigate('/');
  };

  const go = (path) => { setOpen(false); navigate(path); };

  const username = user?.user_metadata?.username || user?.email?.split('@')[0];
  const isAdmin = user?.email === 'kevinman1@gmail.com';

  return (
    <>
      <nav className="navbar">
        <div className="navbar-brand" onClick={() => go('/')}>
          Sell My Stuff<span> Cambodia</span>
        </div>

        {/* Desktop links */}
        <div className="navbar-links">
          {user ? (
            <>
              <span className="nav-user">Hi, {username}</span>
              <button className="nav-btn nav-ghost" onClick={() => go('/sell')}>+ List Item</button>
              <button className="nav-btn nav-ghost" onClick={() => go('/dashboard')}>Dashboard</button>
              {isAdmin && <button className="nav-btn nav-ghost" style={{ color: 'var(--gold-light)', borderColor: 'rgba(201,168,76,.4)' }} onClick={() => go('/admin')}>Admin</button>}
              <NotificationBell />
              <button className="nav-btn nav-ghost" onClick={handleSignOut}>Sign Out</button>
            </>
          ) : (
            <>
              <button className="nav-btn nav-ghost" onClick={() => go('/login')}>Sign In</button>
              <button className="nav-btn nav-primary" onClick={() => go('/register')}>Join Free</button>
            </>
          )}
        </div>

        {/* Hamburger — mobile only */}
        <button className="nav-hamburger" onClick={() => setOpen(o => !o)} aria-label="Menu">
          <span style={{ transform: open ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
          <span style={{ opacity: open ? 0 : 1 }} />
          <span style={{ transform: open ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
        </button>
      </nav>

      {/* Mobile drawer */}
      <div className={`nav-drawer ${open ? 'open' : ''}`}>
        {user ? (
          <>
            <span className="nav-user">Hi, {username}</span>
            <button className="nav-btn nav-primary" onClick={() => go('/sell')}>+ List Item</button>
            <button className="nav-btn nav-ghost" onClick={() => go('/dashboard')}>Dashboard</button>
            {isAdmin && <button className="nav-btn nav-ghost" onClick={() => go('/admin')}>Admin Panel</button>}
            <button className="nav-btn nav-ghost" onClick={handleSignOut}>Sign Out</button>
          </>
        ) : (
          <>
            <button className="nav-btn nav-primary" onClick={() => go('/register')}>Join Free</button>
            <button className="nav-btn nav-ghost" onClick={() => go('/login')}>Sign In</button>
          </>
        )}
      </div>
    </>
  );
}
